module.exports = __webpack_public_path__ + "static/media/blazer.0d869eb7.jpg";